module.exports = __webpack_public_path__ + "img/sumtv.f6048ab9.png";